import { render } from "./FormController.vue?vue&type=template&id=334124b6"
import script from "./FormController.vue?vue&type=script&lang=js"
export * from "./FormController.vue?vue&type=script&lang=js"

import exportComponent from "/opt/esim/admin-src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__